var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultOrgchartManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 18.6667V0H9.33333V9.33333H0V42H18.6667V32.6667H23.3333V42H42V18.6667H32.6667ZM9.33333 37.3333H4.66667V32.6667H9.33333V37.3333ZM9.33333 28H4.66667V23.3333H9.33333V28ZM9.33333 18.6667H4.66667V14H9.33333V18.6667ZM18.6667 28H14V23.3333H18.6667V28ZM18.6667 18.6667H14V14H18.6667V18.6667ZM18.6667 9.33333H14V4.66667H18.6667V9.33333ZM28 28H23.3333V23.3333H28V28ZM28 18.6667H23.3333V14H28V18.6667ZM28 9.33333H23.3333V4.66667H28V9.33333ZM37.3333 37.3333H32.6667V32.6667H37.3333V37.3333ZM37.3333 28H32.6667V23.3333H37.3333V28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOrgchartManagerIcon);
export default __webpack_public_path__ + "static/media/DefaultOrgchartManagerIcon.fa574b7f434c8c842e4752e18f563bf4.svg";
export { ForwardRef as ReactComponent };